import Table from '../../../../../common/components/table';


export const GlobalEventPlansComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedEventValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedEventValues}
                onEdit={handleEdit} headingName="Event Plan Details"
                onDelete={handleDelete} />
        </div>
    )
}
export default GlobalEventPlansComponent;
